var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_vm._t("action",null,null,_vm.slotProps),_vm._v(" "),_vm._t("panel",null,null,_vm.slotProps)],null,_vm.slotProps)],2)}
var staticRenderFns = []

export { render, staticRenderFns }